(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/detail-view-route-result-handler/assets/javascripts/detail-view-route-result-handler.js') >= 0) return;  svs.modules.push('/components/tipsen/detail-view-route-result-handler/assets/javascripts/detail-view-route-result-handler.js');
"use strict";


const {
  Route,
  useRouteMatch
} = ReactRouterDOM;
const {
  useMediaQuery
} = svs.components.lbUtils.useMediaQuery;
const {
  SideNav,
  LazyStatistic,
  LazyWinnerstories,
  LazyCompetitionResult,
  LazyQuickBet
} = svs.components.tipsen.sideNav;
const {
  TipsenModuleGameUrl
} = svs.components.sport.tipsenShared;
const {
  useBranding,
  useGetIsMatchNotStartedOrLive
} = svs.components.tipsen.hooks;
const {
  useCurrentDrawEvent,
  useDrawSearchParams,
  useCurrentDraw
} = svs.components.tipsen.drawProvider.hooks;
const {
  STATISTIC_SIDEBAR_QUERY
} = svs.components.tipsen.constants;
const {
  SportinfoPathNames
} = svs.components.sportinfo.common.constants;
const {
  DetailViewMobileHandler
} = svs.components.tipsen.detailViewMobileHandler;
const {
  useGetSelectedEventNumber
} = svs.components.tipsen.hooks;
const {
  useCompetitionDesc,
  useCompetitionType
} = svs.components.marketplaceCompetition.services.hooks;
const {
  CompetitionType
} = svs.components.marketplaceCompetition.constants;
const {
  getProductBrandByDraw
} = svs.components.lbUtils.brandMapping.fn;
const getMenuItems = (drawSearchParams, menuItemPathsPrefix, competitionId, competitionDesc, compSubUrl, drawNumber, isMatchNotStartedOrLive, matchId, sportType, shouldBlurCompetitionContent) => {
  var _svs$tipsen$data$winn, _svs;
  const menuItems = {
    STATISTICS: {
      to: {
        pathname: '',
        search: drawSearchParams
      },
      icon: 'statistics',
      label: 'Statistik',
      testIdSuffix: 'statistic',
      Component: LazyStatistic,
      selectedOnPaths: ["/".concat(menuItemPathsPrefix), "/".concat(menuItemPathsPrefix, "/").concat(SportinfoPathNames.News), "/".concat(menuItemPathsPrefix, "/").concat(SportinfoPathNames.Table), "/".concat(menuItemPathsPrefix, "/").concat(SportinfoPathNames.Statistic), "/".concat(menuItemPathsPrefix, "/").concat(SportinfoPathNames.Lineup), "/".concat(menuItemPathsPrefix, "/").concat(SportinfoPathNames.Mutuals), "/".concat(menuItemPathsPrefix, "/").concat(SportinfoPathNames.Events), "/".concat(menuItemPathsPrefix, "/").concat(SportinfoPathNames.PlayMakerXstat)]
    },
    WINNERSTORIES: {
      to: {
        pathname: '/vinnarstories',
        search: drawSearchParams
      },
      icon: 'win',
      label: 'Vinnarstories',
      testIdSuffix: 'winnerstories',
      Component: LazyWinnerstories,
      selectedOnPaths: ["/".concat(menuItemPathsPrefix, "/vinnarstories")]
    },
    TIPSSM: {
      to: {
        pathname: "/".concat(compSubUrl),
        search: drawSearchParams
      },
      icon: 'trophy-tips-sm',
      label: competitionDesc,
      testIdSuffix: 'tipssm',
      Component: LazyCompetitionResult,
      selectedOnPaths: ["/".concat(menuItemPathsPrefix, "/").concat(TipsenModuleGameUrl.TIPS_SM, "(/lag)?"), "/".concat(menuItemPathsPrefix, "/").concat(TipsenModuleGameUrl.TIPS_SM, "/lag/:teamId(\\d+)?"), "/".concat(menuItemPathsPrefix, "/").concat(TipsenModuleGameUrl.TIPS_EM, "(/lag)?"), "/".concat(menuItemPathsPrefix, "/").concat(TipsenModuleGameUrl.TIPS_EM, "/lag/:teamId(\\d+)?")],
      props: {
        competitionId,
        drawNumber,
        shouldBlurCompetitionContent
      }
    },
    QUICKBET: {
      to: {
        pathname: "/".concat(TipsenModuleGameUrl.QUICK_BET),
        search: drawSearchParams
      },
      icon: 'odds',
      label: 'Oddset',
      testIdSuffix: 'quickbet',
      Component: LazyQuickBet,
      selectedOnPaths: ["/".concat(menuItemPathsPrefix, "/").concat(TipsenModuleGameUrl.QUICK_BET)],
      props: {
        matchId,
        sportType
      }
    }
  };
  const menuItemsList = [menuItems.STATISTICS];
  const smallDeviceMenuItemsList = [menuItems.STATISTICS];
  if (isMatchNotStartedOrLive && sportType && matchId) {
    menuItemsList.push(menuItems.QUICKBET);
    smallDeviceMenuItemsList.push(menuItems.QUICKBET);
  }
  const winnerStoriesEnabled = (_svs$tipsen$data$winn = (_svs = svs) === null || _svs === void 0 || (_svs = _svs.tipsen) === null || _svs === void 0 || (_svs = _svs.data) === null || _svs === void 0 || (_svs = _svs.winnerStoriesConfig) === null || _svs === void 0 || (_svs = _svs.winnerStories) === null || _svs === void 0 ? void 0 : _svs.enabled) !== null && _svs$tipsen$data$winn !== void 0 ? _svs$tipsen$data$winn : false;
  if (winnerStoriesEnabled) {
    menuItemsList.push(menuItems.WINNERSTORIES);
  }
  if (competitionId) {
    menuItemsList.unshift(menuItems.TIPSSM);
  }
  return [menuItemsList, smallDeviceMenuItemsList];
};
const DetailViewRouteResultHandler = _ref => {
  let {
    drawNumber,
    productId,
    menuItemPathsPrefix,
    hasSideNav = true,
    competitionId,
    maskedOutcomes = [],
    shouldBlurCompetitionContent = false
  } = _ref;
  const sideNavOverflowClass = 'tipsen-side-nav-overflow';
  const isWideDevice = useMediaQuery(STATISTIC_SIDEBAR_QUERY);
  const match = useRouteMatch();
  const drawId = "".concat(productId, "_").concat(drawNumber);
  const event = useCurrentDrawEvent(drawId);
  const draw = useCurrentDraw();
  let sportType;
  if (draw) {
    sportType = draw.sportType;
  }
  const matchId = event.matchId;
  const selectedEventNumber = useGetSelectedEventNumber();
  const drawSearchParams = useDrawSearchParams(productId, drawNumber, selectedEventNumber, true).toString();
  const brandingByDraw = getProductBrandByDraw({
    productId
  });
  const brandingList = useBranding();
  const branding = brandingByDraw || brandingList[brandingList.length - 1] || brandingList[0] || 'sport';
  const competitionDesc = useCompetitionDesc(competitionId);
  const competitionType = useCompetitionType(competitionId);
  const compSubUrl = competitionType === CompetitionType.TipsEM ? TipsenModuleGameUrl.TIPS_EM : TipsenModuleGameUrl.TIPS_SM;
  const isMatchNotStartedOrLive = useGetIsMatchNotStartedOrLive(matchId);
  const hasCompetition = competitionId && competitionType && competitionDesc;
  const [menuItems, smallDeviceMenuItems] = getMenuItems(drawSearchParams, menuItemPathsPrefix, hasCompetition ? competitionId : undefined, competitionDesc, compSubUrl, drawNumber, isMatchNotStartedOrLive, matchId, sportType, shouldBlurCompetitionContent);
  const eventIndex = event.eventNumber - 1;
  const eventCount = draw === null || draw === void 0 ? void 0 : draw.eventCount;
  const matchCount = draw === null || draw === void 0 ? void 0 : draw.matchCount;
  const hasPeriods = matchCount === 1 && eventCount > 1;
  const hasMaskedOutcomes = maskedOutcomes.includes(eventIndex) || hasPeriods && maskedOutcomes.length > 0;
  const ariaLabel = hasCompetition ? 'Tävlingsinformation och statistik' : 'Statistik';
  if (isWideDevice && hasSideNav) {
    return React.createElement(SideNav, {
      ariaLabel: ariaLabel,
      match: match,
      menuItems: menuItems
    }, React.createElement(Route, {
      render: () => React.createElement(LazyStatistic, {
        bigStattabAreaClassName: sideNavOverflowClass,
        branding: branding,
        drawNumber: drawNumber,
        hasMaskedOutcomes: hasMaskedOutcomes,
        matchId: matchId,
        productId: productId,
        shouldSaveDrawParams: true
      })
    }));
  } else if (!isWideDevice) {
    return React.createElement(DetailViewMobileHandler, {
      drawId: drawId,
      extraMenuItems: smallDeviceMenuItems,
      hasMaskedOutcomes: hasMaskedOutcomes
    }, React.createElement(LazyStatistic, {
      branding: branding,
      drawNumber: drawNumber,
      hasMaskedOutcomes: hasMaskedOutcomes,
      matchId: matchId,
      productId: productId,
      shouldSaveDrawParams: true
    }));
  }
  return null;
};
setGlobal('svs.components.tipsen.detailViewRouteResultHandler.DetailViewRouteResultHandler', DetailViewRouteResultHandler);

 })(window);